import React, { Component } from 'react'
import { Field } from 'redux-form/immutable'
import { Redirect } from 'react-router-dom'

import Spinner from 'app/components/Spinner'
import Input from 'app/components/Input'
import Button from 'app/components/ButtonDefault'
import { required, email } from 'helpers/validators'
import InputPhoneNumber from 'app/domains/common/InputPhoneNumber'
import LoginInformationModal from 'app/domains/routes/Login/LoginInformationModal'
import CheckEmailSpamIcon from 'app/components/SVGS/CheckEmailSpamIcon'

import './styles.scss'
export const bc = 'start-invite'
class Start extends Component {
  hideFreshWidgetCustomImage = () => {
    // freshWidgetCollection is HTMLCollection, must be one on the page
    const freshWidgetCollection = document.getElementsByClassName('freshwidget-customimage')
    if (freshWidgetCollection && freshWidgetCollection.length) {
      freshWidgetCollection.item(0).style.display = 'none'
    }
  }

  componentDidUpdate() {
    const { showModal } = this.props
    const { isShowLoginInformationModal } = this.props
    this.hideFreshWidgetCustomImage()
    if (isShowLoginInformationModal) {
      showModal(
        <LoginInformationModal
          title="Don’t see your invite email? "
          text="Check Spam – it might have gone there, right next to that message from your long lost uncle with all that inheritance money."
          icon={<CheckEmailSpamIcon />}
          clearAuthStatuses={() => {}}
          withoutCross
        />,
        {
          size: 'xs',
          onRequestClose: () => {},
        }
      )
    }
  }

  componentDidMount() {
    this.props.closeShowLoginInformationModal()
  }

  render() {
    const { title, subTitle, image, handleSubmit, form, invalid, isPromoPageActive, pending } = this.props
    if (isPromoPageActive) {
      return (
        <div className={`${bc}__wrapper`}>
          <div className={`${bc}__content`}>
            <div className={`${bc}__image-wrapper`}>
              <img src={image} alt="Start ProHabits" className={`${bc}__image`} />
            </div>
            <div className={`${bc}__body`}>
              <span className={`${bc}__title`}>{title}</span>
              <span className={`${bc}__subtitle`}>{subTitle}</span>
              <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                <Field
                  name="firstName"
                  component={Input}
                  label="First Name"
                  labelClass={`${bc}__label`}
                  placeholder="Enter first name"
                  className={`${bc}__input-wrapper`}
                  validate={[required()]}
                />
                <Field
                  name="lastName"
                  component={Input}
                  label="Last Name"
                  labelClass={`${bc}__label`}
                  placeholder="Enter last name"
                  className={`${bc}__input-wrapper`}
                  validate={[required()]}
                />
                <Field
                  name="email"
                  component={Input}
                  label="Email"
                  labelClass={`${bc}__label`}
                  placeholder="Enter email"
                  className={`${bc}__input-wrapper`}
                  validate={[required(), email]}
                />
                <InputPhoneNumber
                  label="Mobile Number (Optional)"
                  labelClass={`${bc}__label`}
                  className={`${bc}__input-wrapper`}
                  inputClass={`${bc}__input`}
                  form={form}
                  classNamePhoneComponentWrapper={`${bc}__select-phone-code`}
                  classNamePhoneComponentItem={`${bc}__select-phone-code`}
                />
                <Button className={`${bc}__button`} type="submit" disabled={invalid}>
                  Start ProHabits
                </Button>
              </form>
            </div>
          </div>
        </div>
      )
    }
    if (!pending && !isPromoPageActive) {
      return <Redirect from="/start" to="/login" />
    }
    return <Spinner />
  }
}

Start.defaultProps = {
  image: 'https://assets.prohabits.com/prohabits/welcome-promo-page-default_488x274.jpg',
  title: 'Inspiration without action is daydreaming.',
  subTitle: 'Do you commit to being more human at work?',
  pending: true,
  isPromoPageActive: false,
}

export default Start
